import { handleActions } from 'redux-actions';
import { yyyymmdd } from '@/utils/date';
import moment from 'moment'
import { isMobile } from 'react-device-detect';
import { getHolidayText } from '@/utils/string'

import types from '@/actions/mainTypes';

const initialState = {
  empNo: localStorage.empNo,
  date: yyyymmdd(new Date()),
  showTable: false,
  workTimeList: [],
  removedTimeList: [],
  inoutTimeList: [],
  isOpenAddExceptModal: false,
  isOpenModifyTimeModal: false,
  isOpenModifyTimeExModal: false,
  selfExceptTimeInfo: {
    date: '',
    hour: 0,
    minute: 0
  },
  modifyTimeInfo: {
    type: '',
    date: '',
    hour: 0,
    minute: 0
  },
  modifyTimeExInfo: {
    date: '',
    firstHour: 0,
    firstMinute: 0,
    lastHour: 0,
    lastMinute: 0
  },
  saveAttendanceInfo: {
    date: '',
    holiday: ''
  },
  monthlyWorkTime: {},
  monthlyRequiredWorkTime1: 0,
  monthlyRequiredWorkTime2: 0,
  monthlyRequiredWorkTimeType: '',
  workTimeListCalendar: [],
  workHomePartMap: {}
};

/* Reducer */
export default handleActions({
  [types.UPDATE_EMPNO]: (state, action) => {
    return { ...state,
      empNo: action.value,
      workTimeList: [],
      removedTimeList: [],
      showTable: false,
      inoutTimeList: false,
      monthlyWorkTime: {}
    }
  },
  [types.UPDATE_DATE]: (state, action) => {
    return { ...state,
      date: action.value
    }
  },
  [types.UPDATE_SELF_EXCEPT_HOUR]: (state, action) => {
    return { ...state,
      selfExceptTimeInfo: {
        ...state.selfExceptTimeInfo,
        hour: action.value
      }
    }
  },
  [types.UPDATE_SELF_EXCEPT_MINUTE]: (state, action) => {
    return { ...state,
      selfExceptTimeInfo: {
        ...state.selfExceptTimeInfo,
        minute: action.value
      }
    }
  },
  [types.SET_GOHOME_DATA]: (state, action) => {
    const workTimeList = action.data;
    let removedTimeList, inoutTimeList;
    for (let obj of workTimeList) {
      if (obj.removedTimeList) {
        removedTimeList = obj.removedTimeList;
        delete obj.removedTimeList;
      }
      if (obj.inoutHistory) {
        inoutTimeList = obj.inoutHistory;
        delete obj.inoutHistory;
      }
    }
    return { ...state,
      showTable: true,
      monthlyWorkTime: {},
      workTimeList,
      removedTimeList,
      inoutTimeList,
    }
  },
  [types.OPEN_ADD_EXCEPT]: (state, action) => {
    return { ...state,
      isOpenAddExceptModal: true,
      selfExceptTimeInfo: {
        date: action.date,
        hour: action.hour,
        minute: action.minute,
      }
    }
  },
  [types.CLOSE_ADD_EXCEPT]: (state, action) => {
    return { ...state,
      isOpenAddExceptModal: false
    }
  },
  [types.OPEN_MODIFY_TIME]: (state, action) => {
    return { ...state,
      isOpenModifyTimeModal: true,
      modifyTimeInfo: {
        type: action.modifyType,
        date: action.date,
        originTime: action.originTime,
        hour: action.hour,
        minute: action.minute,
        modified: action.modified
      }
    }
  },
  [types.CLOSE_MODIFY_TIME]: (state, action) => {
    return { ...state,
      isOpenModifyTimeModal: false
    }
  },
  [types.OPEN_SAVE_ATTENDANCE]: (state, action) => {
    return { ...state,
      isOpenSaveAttendanceModal: true,
      saveAttendanceInfo: {
        date: action.date,
        holiday: action.holiday
      }
    }
  },
  [types.CLOSE_SAVE_ATTENDANCE]: (state, action) => {
    return { ...state,
      isOpenSaveAttendanceModal: false
    }
  },
  [types.SET_MONTHLY_WORK_TIME]: (state, action) => {
    return { ...state,
      monthlyWorkTime: action.data
    }
  },
  [types.SET_MONTHLY_REQUIRED_WORK_TIME]: (state, action) => {
    return { ...state,
      monthlyRequiredWorkTime1: action.type1Hours,
      monthlyRequiredWorkTime2: action.type2Hours,
      monthlyRequiredWorkTimeType: action.requiredHoursType
    }
  },
  [types.UPDATE_MODIFY_TIME_HOUR]: (state, action) => {
    return { ...state,
      modifyTimeInfo: {
        ...state.modifyTimeInfo,
        hour: action.value
      }
    }
  },
  [types.UPDATE_MODIFY_TIME_MINUTE]: (state, action) => {
    return { ...state,
      modifyTimeInfo: {
        ...state.modifyTimeInfo,
        minute: action.value
      }
    }
  },
  [types.SET_GOHOME_DATA_MONTHLY_ALL]: (state, action) => {
    if (isMobile) {
      return { ...state,
        workTimeListCalendar: action.data
      }
    }
    const data = []
    let index = 0;
    for (let o of action.data) {
      if (o.holiday) {
        data.push({
          id: index++,
          title: getHolidayText(o.holiday),
          start: moment(o.date).toDate(),
          end: moment(o.date).add(1,'day').toDate(),
          allDay: true,
          key: 'holiday'
        })
      }
      for (let key of Object.keys(o)) {
        if (key === 'date' || key === 'firstTime' || key === 'lastTime' || key === 'holiday' || key === 'requiredWorkingMinutes' || key === 'accumulateWorkMinutesMonthly') continue;
        if (key === 'publicHoliday') {
          data.push({
            id: index++,
            title: o[key],
            start: moment(o.date).toDate(),
            end: moment(o.date).add(1,'day').toDate(),
            allDay: true,
            key: key
          })
          continue;
        }
        if (o[key] === 'half') {
          data.push({
            id: index++,
            title: '반차',
            start: moment(o.date).toDate(),
            end: moment(o.date).add(1,'day').toDate(),
            allDay: true,
            key: key
          })
          continue;
        }
        data.push({
          id: index++,
          title: `${convertTimeTitle(key)} : ${o[key]}`,
          start: moment(o.date).toDate(),
          end: moment(o.date).add(1,'day').toDate(),
          allDay: true,
          key: key
        })
      }
    }
    return { ...state,
      workTimeListCalendar: data
    }
  },
  [types.SET_WORKHOME_PART_DATA]: (state, action) => {
    return { ...state,
      workHomePartMap: action.data
    }
  },
  [types.OPEN_MODIFY_TIME_EX]: (state, action) => {
    return { ...state,
      isOpenModifyTimeExModal: true,
      modifyTimeExInfo: {
        date: action.date,
        firstHour: action.firstHour,
        firstMinute: action.firstMinute,
        lastHour: action.lastHour,
        lastMinute: action.lastMinute,
        modified: action.modified
      }
    }
  },
  [types.CLOSE_MODIFY_TIME_EX]: (state, action) => {
    return { ...state,
      isOpenModifyTimeExModal: false
    }
  },
  [types.UPDATE_MODIFY_TIME_EX]: (state, action) => {
    return { ...state,
      modifyTimeExInfo: {
        ...state.modifyTimeExInfo,
        [action.target]: action.value
      }
    }
  },
}, initialState);

const convertTimeTitle = (key) => {
  switch (key) {
    case "removedTime" : return "휴식시간"
    case "accumulateWorkMonthlyTime" : return "누적시간"
    case "status" : return "여유시간"
    default: return "근무시간"
  }
}



// WEBPACK FOOTER //
// ./src/reducers/mainReducer.js